import { useEffect, useState } from 'react';

import { buttons } from '@/styles/buttons';

import { ChevronRightIcon } from '@/ui/Icons/ChevronRightIcon';

export function SlotMachine() {
  const [activeReels, setActiveReels] = useState(Array(6).fill(false));
  const [timeouts, setTimeouts] = useState<number[]>([]);

  useEffect(() => {
    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, [timeouts]);

  const startAnimation = () => {
    timeouts.forEach(clearTimeout);
    setTimeouts([]);

    setActiveReels(Array(6).fill(true));

    const newTimeouts = activeReels.map((_, index) => {
      return window.setTimeout(
        () => {
          setActiveReels((prev) => prev.map((v, i) => (i === index ? false : v)));
        },
        Math.random() * (4000 - 1000) + 1000, // Random second between 1s and 4s.
      );
    });

    setTimeouts(newTimeouts);
  };

  return (
    <div
      className={`h-[320px] overflow-hidden desktop:overflow-visible desktop:ml-8 px-4 tablet:h-[265px] tablet:w-[370px] desktop:w-auto`}
    >
      <div
        className={`my-auto mx-[50%] transform translate-x-[-50%] flex items-center justify-center gap-3 h-full w-fit relative tablet:mx-[35%] desktop:mx-0 desktop:translate-x-0`}
      >
        <div
          className={`bg-center bg-repeat-y bg-[length:60px_auto] h-full rotate-[-6deg] transition-all duration-[1.5s] ease-in-out w-[55px] z-[1] bg-[url(/images/matcha-auto/slot-machine-1.png)] ${activeReels[0] && 'bg-[position:0_200%]'}`}
        ></div>
        <div
          className={`bg-center bg-repeat-y bg-[length:50px_auto] h-full rotate-[-6deg] transition-all duration-[1.5s] ease-in-out w-[55px] z-[1] bg-[url(/images/matcha-auto/slot-machine-2.png)] ${activeReels[1] && 'bg-[position:0_200%]'}`}
        ></div>
        <div
          className={`bg-center bg-repeat-y bg-[length:60px_auto] h-full rotate-[-6deg] transition-all duration-[1.5s] ease-in-out w-[55px] z-[1] bg-[url(/images/matcha-auto/slot-machine-3.png)] ${activeReels[2] && 'bg-[position:0_200%]'}`}
        ></div>

        <button
          aria-label="play token slot machine"
          className={buttons({
            size: 'medium',
            iconOnly: true,
            color: 'white',
            class: [
              'h-auto',
              'm-4',
              'p-4',
              'transition-[all_0.5s_ease-in-out]',
              'hover:scale-[1.2]',
              'hover:transform',
              'hover:bg-primitive-basic-white',
              "before:content-['']",
              'before:h-[226px]',
              'before:w-[226px]',
              'before:absolute',
              'before:bg-[url(/images/matcha-auto/slot-machine-lines.svg)]',
              'before:bg-no-repeat',
              'before:bg-center',
            ],
            shape: 'circle',
          })}
          onClick={startAnimation}
        >
          <ChevronRightIcon className="size-3.5" />
        </button>
        <div
          className={`bg-center bg-repeat-y bg-[length:60px_auto] h-full rotate-[-6deg] transition-all duration-[1.5s] ease-in-out w-[55px] z-[1] bg-[url(/images/matcha-auto/slot-machine-4.png)] ${activeReels[3] && 'bg-[position:0_200%]'}`}
        ></div>
        <div
          className={`bg-center bg-repeat-y bg-[length:50px_auto] h-full rotate-[-6deg] transition-all duration-[1.5s] ease-in-out w-[55px] z-[1] bg-[url(/images/matcha-auto/slot-machine-5.png)] ${activeReels[4] && 'bg-[position:0_200%]'}`}
        ></div>
        <div
          className={`bg-center bg-repeat-y bg-[length:60px_auto] h-full rotate-[-6deg] transition-all duration-[1.5s] ease-in-out w-[55px] z-[1] bg-[url(/images/matcha-auto/slot-machine-6.png)] ${activeReels[5] && 'bg-[position:0_200%]'}`}
        ></div>
      </div>
    </div>
  );
}
